import React, { useMemo } from "react";
import { Badge, Button, Form, Modal, Spinner } from "react-bootstrap";
import SimpleTable from "../../comman/custom-table/SimpleTable";
import CloseBtn from "../CloseBtn";

const ImportModal = ({
  show,
  onHide,
  onExit,
  importSuccess,
  importReport,
  importing,
  onImport,
  downloadValidationErrorsCsv,
}) => {
  const rows = useMemo(
    () =>
      (importReport?.errors ?? []).map((e, i) => ({
        ...e,
        _sr: i + 1,
      })),
    [importReport]
  );

  const columns = useMemo(
    () => [
      {
        header: "Sr.",
        accessor: "_sr",
        minWidth: 60,
        className: "text-nowrap text-center fw-semibold",
      },
      {
        header: "Row",
        accessor: "row",
        minWidth: 80,
        className: "text-nowrap text-center fw-semibold",
      },
      {
        header: "Errors",
        accessor: "errors",
        minWidth: 240,
        className: "fw-semibold",
        cell: (val) => (
          <ul className="mb-0 ps-3">
            {(val ?? []).map((msg, idx) => (
              <li key={idx}>{String(msg)}</li>
            ))}
          </ul>
        ),
      },
      {
        header: "Data (original)",
        accessor: "data",
        minWidth: 320,
        className: "text-wrap fw-semibold",
        cell: (val) => (
          <code
            className="small d-block"
            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {JSON.stringify(val ?? {}, null, 0)}
          </code>
        ),
      },
    ],
    []
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      onExited={onExit}
      centered
      size={importSuccess && importReport ? "xl" : "md"}
      backdrop={importing ? "static" : true}
      keyboard={!importing}
    >
      {!importing && <CloseBtn onClick={onHide} color="#bf352b" />}

      <Modal.Header>
        <Modal.Title>Import Partners from Excel</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {importing ? (
          <div className="text-center my-4">
            <Spinner animation="border" role="status" />
            <div className="mt-2">Importing… please wait</div>
          </div>
        ) : (
          <>
            {importSuccess === null && (
              <Form.Group className="mb-3">
                <Form.Label>Select .xlsx/.xls file</Form.Label>
                <Form.Control
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={onImport}
                />
                <div className="text-muted small">
                  Ensure your file matches the required format.
                </div>
              </Form.Group>
            )}

            {importSuccess === true && importReport && (
              <div className="d-grid columns-4 gap-3">
                <Badge bg="secondary" className="p-2">
                  Total: {importReport.totalRows ?? 0}
                </Badge>
                <Badge bg="success" className="p-2">
                  Created: {importReport.createdCount ?? 0}
                </Badge>
                <Badge bg="info" className="p-2">
                  Updated: {importReport.updatedCount ?? 0}
                </Badge>
                <Badge bg="danger" className="p-2">
                  Errors: {importReport.errorCount ?? 0}
                </Badge>
              </div>
            )}

            {importSuccess === false && importReport && (
              <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0">Validation Errors</h6>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => downloadValidationErrorsCsv(importReport)}
                  >
                    Download errors (.csv)
                  </Button>
                </div>

                <SimpleTable
                  data={rows}
                  columns={columns}
                  loading={false}
                  keyField="_sr"
                  size="sm"
                  responsive
                  emptyMessage="No errors found"
                />
              </div>
            )}
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        {importing ? (
          <Button variant="secondary" disabled>
            <Spinner animation="border" size="sm" className="me-2" />
            Importing…
          </Button>
        ) : importSuccess === null ? (
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        ) : (
          <Button variant="outline-secondary" onClick={onHide}>
            Done
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ImportModal;
